import axios from 'axios';
async function regSw () {
  if ('serviceWorker' in navigator) {
    // Register the service worker from the same origin at /sw.js to avoid scope issues.
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    // Wait until the service worker is active and ready.
    await navigator.serviceWorker.ready;
    // Ensure the active worker is fully activated before subscribing.
    if (!reg.active && reg.installing) {
      await new Promise((resolve) => {
        const worker = reg.installing;
        const onStateChange = () => {
          if (worker.state === 'activated') {
            worker.removeEventListener('statechange', onStateChange);
            resolve();
          }
        };
        worker.addEventListener('statechange', onStateChange);
      });
    }
    console.log ('service config is', {reg});
    return reg;
  }
  throw Error ('serviceworker not supported');
}
const serverURL = process.env.REACT_APP_API;
async function subscribe(serviceWorkerReg,userName,total) {
    try {
      if (!('PushManager' in window)) {
        throw new Error('PushManager is not supported in this browser.');
      }
      if (!window.isSecureContext) {
        throw new Error('Push notifications require a secure context (HTTPS) or localhost.');
      }
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        throw new Error(`Notification permission not granted (status: ${permission}).`);
      }

      let subscription = await serviceWorkerReg.pushManager.getSubscription();
      console.log({ subscription });
      
      if (subscription === null) {
        subscription = await serviceWorkerReg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array('BLB6VrmSaIaUCPcpmEizbRC0ebwz7YWZaztxSzqiUJ_zDSv22F4mSBhs4fHh71WNLSxAzN61ROnokFYgg9y-6c4'),
        });
  
        // Replace 'YOUR_SERVER_URL' with the actual server URL
       // Replace with your server URL
       const subscriptionData = {
        subscription,
        userName,
        total,
      };
        await axios.post(`${serverURL}/subscribe`, subscriptionData);
      } else {
        // If already subscribed locally, still send to server to ensure it's registered
        const subscriptionData = { subscription, userName, total };
        await axios.post(`${serverURL}/subscribe`, subscriptionData);
      }
    } catch (error) {
      console.error('Subscription failed:', {
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
        permission: typeof Notification !== 'undefined' ? Notification.permission : 'unknown',
        isSecureContext: window.isSecureContext,
        swScope: serviceWorkerReg?.scope,
        swState: serviceWorkerReg?.active?.state,
      });
    }
  }
  
  // Utility to convert VAPID key
  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
  
  export {regSw, subscribe};
